<template>
  <vs-popup title="안전위반통보서 발부기준" :active.sync="isActive" class="violation-criteria-popup">
    <div class="violation-criteria">
      <div class="process-line">
        <span class="section-title">안전위반통보서 Process</span>
        <span class="process-badge">발부 및 승인 (안전환경부서장) &amp; D-SaFe 전산 등록</span>
      </div>

      <div class="section-title mt-4">안전위반통보서 발부기준</div>
      <div v-for="category in 위반유형목록" :key="category.유형" class="criteria-row">
        <div class="criteria-label">{{ category.유형 }}</div>
        <ul class="criteria-items">
          <li v-for="(item, itemIndex) in category.항목" :key="`${category.유형}-${itemIndex}`">{{ item }}</li>
        </ul>
      </div>

      <p class="notice-sub">※ 그 밖의 안전환경팀장이 안전위반통보서 발부가 필요하다고 판단되는 사항</p>
    </div>
  </vs-popup>
</template>

<script>
import { 위반유형목록 } from "./violationData";

export default {
  props: {
    value: Boolean,
  },
  computed: {
    isActive: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      위반유형목록,
    };
  },
};
</script>

<style lang="scss" scoped>
.violation-criteria-popup ::v-deep .vs-popup {
  width: 900px;
  max-width: 95vw;
}
.violation-criteria {
  padding: 4px;
}
.section-title {
  display: inline-block;
  font-size: 15px;
  font-weight: 700;
  color: #2e3f54;
  border-left: 5px solid #2e3f54;
  padding-left: 8px;
  margin-bottom: 10px;
}
.process-line {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  .process-badge {
    background: #e8edf5;
    color: #2e3f54;
    font-size: 13px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 3px;
    margin-bottom: 10px;
  }
}
.criteria-row {
  display: flex;
  gap: 14px;
  margin-bottom: 12px;
  align-items: flex-start;

  .criteria-label {
    flex-shrink: 0;
    width: 130px;
    background: #4a5d78;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    text-align: center;
    padding: 8px 6px;
    word-break: keep-all;
  }

  .criteria-items {
    flex: 1;
    margin: 0;
    padding: 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 3px;
    list-style: none;

    li {
      position: relative;
      padding-left: 12px;
      margin-bottom: 4px;
      font-size: 13px;
      line-height: 1.6;
      color: #333;
      word-break: keep-all;

      &::before {
        content: "·";
        position: absolute;
        left: 0;
        font-weight: 700;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.notice-sub {
  margin: 14px 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #555;
  text-decoration: underline;
  text-align: center;
  word-break: keep-all;
}

@media (max-width: 768px) {
  .criteria-row {
    flex-direction: column;
    gap: 6px;

    .criteria-label {
      width: 100%;
    }
  }
}
</style>
